import React from 'react';
import {createSelector} from 'reselect';
import PropTypes from 'prop-types';
import './style.scss';

import {Button} from '../Button';
import {scrollToSectionTop} from '@learningblocks/protocol-constants/lib/Utilities';
//import IconHexagon from '@learningblocks/exp-constants/lib/Icons/more-solid'

const CONTENT_SECTION_SELECTOR = 'div.notebook-content__body';

export class SkipSection extends React.Component {

  goToNextSection = () => {
    scrollToSectionTop(CONTENT_SECTION_SELECTOR);
    this.props.toNextSection(this.props.section);
  };

  render() {
    return(
      <div className={this.props.className}>
        <p tabIndex={0}>{this.props.message}</p>
        <div className="callToAction">
          <Button className='nextSection' onClick={this.goToNextSection}>
            Skip >
          </Button>
        </div>
      </div>
    )
  }

}
SkipSection.propTypes = {
  type: PropTypes.string,
  content: PropTypes.array,
  message: PropTypes.string.isRequired,
  className: PropTypes.string,

  nextSection: PropTypes.object,
  toNextSection: PropTypes.func,
};

SkipSection.defaultProps = {
  className: 'skipSection',
};
